import { Editor, Element, Transforms } from 'slate';
import { elements } from '../elements';
import { useSlate } from 'slate-react';
import useEmailEditor from './useEmailEditor';

const useSelectedElement = () => {
    const editor = useSlate();
    const { selectedPath, setSelectedPath } = useEmailEditor();

    const getSelectedElement = () => {
        const selectedElement = Editor.above(editor, {
            match: n =>
                Element.isElement(n) && elements[n.type]?.isSelectableBlock,
        });

        if (selectedElement) {
            // setSelectedPath(null);
            return selectedElement;
        }

        if (!selectedPath) return [];
        if (!Editor.hasPath(editor, selectedPath)) {
            // setSelectedPath(null);
            return [];
        }

        return Editor.node(editor, selectedPath);
    };

    const setSelectedElement = path => {
        editor.deselect();
        setSelectedPath(path);
    };

    const deselectElement = () => {
        editor.deselect();
        setSelectedPath(null);
    };

    const removeElement = () => {
        Transforms.removeNodes(editor, { at: getSelectedElement()[1] });
    };

    return {
        getSelectedElement,
        setSelectedElement,
        deselectElement,
        removeElement,
    };
};

export default useSelectedElement;
